import { PUBLISH_STATES } from '../api/NewsQueueApiConstants';

export const NEWS_QUEUE_TITLE = 'ROUSKU';

export const FILTER_HEADER_HEIGHT_BASE = 32;
export const FILTER_HEADER_HEIGHT_FILTERS = 64;

export const DEFAULT_SORT_DIRECTION = 'desc'; // 'desc' | 'asc'
export const NEWS_DELTA_POLL_INTERVAL_MS = 30_000;
export const NEWS_NEW_BADGE_WINDOW_MS = 5 * 60 * 1000;
export const NEWS_NEW_HIGHLIGHT_FADE_MS = 2_400;

export const UI_PUBLISH_STATES = {
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
};

export const API_TO_UI_PUBLISH_STATE = {
    [PUBLISH_STATES.NEW]: UI_PUBLISH_STATES.PENDING,
    [PUBLISH_STATES.ERROR]: UI_PUBLISH_STATES.PENDING,
    [PUBLISH_STATES.PUBLISHED]: UI_PUBLISH_STATES.ACCEPTED,
    [PUBLISH_STATES.DRAFT]: UI_PUBLISH_STATES.ACCEPTED,
    [PUBLISH_STATES.REJECTED]: UI_PUBLISH_STATES.REJECTED,
};

export function toUiPublishState(publishState) {
    const normalized = String(publishState ?? '').toLowerCase();
    return API_TO_UI_PUBLISH_STATE[normalized] ?? null;
}

export const PUBLISH_STATE_OPTIONS = [
    { value: UI_PUBLISH_STATES.PENDING, label: 'Odottaa' },
    { value: UI_PUBLISH_STATES.ACCEPTED, label: 'Hyväksytty' },
    { value: UI_PUBLISH_STATES.REJECTED, label: 'Hylätty' },
];

export const ALL_TARGET_MEDIA_VALUES = [
    'HelsinginUutiset',
    'Länsiväylä',
    'VihdinUutiset',
    'Aamuposti',
    'Tamperelainen',
    'SipoonSanomat'
];

// TODO: delete later — legacy and registry spellings for the same outlet.
export const TARGET_MEDIA_EQUIVALENTS = {
    LänsiUusimaa: ['LänsiUusimaa', 'Länsi-Uusimaa'],
    KeskiUusimaa: ['KeskiUusimaa', 'Keski-Uusimaa'],
};

// Deprecated: canonicalTargetMediaValue is no longer used since we removed canonicalization.
// Kept for reference but not called anywhere.
export function canonicalTargetMediaValue(value) {
    // Now just returns the trimmed value without any transformation
    return String(value ?? '').trim();
}

// Simplified: normalizeTargetMediaList now just deduplicates and filters without canonicalization
export function normalizeTargetMediaList(values) {
    return Array.from(
        new Set((values ?? []).map(String).map(v => v.trim()).filter(Boolean))
    );
}

// Simplified: expandTargetMediaFilterValues now just deduplicates without canonicalization
export function expandTargetMediaFilterValues(selectedValues) {
    return new Set((selectedValues ?? []).map(String).map(v => v.trim()).filter(Boolean));
}

function getArticleTargetMediaValues(item) {
    const value = item?.target_media;
    if (!value) return [];

    if (Array.isArray(value)) {
        return value
            .map((entry) => String(entry ?? '').trim())
            .filter(Boolean);
    }

    const normalized = String(value).trim();
    return normalized ? [normalized] : [];
}

export function articleMatchesTargetMediaFilter(item, selectedTargetMedias) {
    if (!selectedTargetMedias?.length) return true;

    const allowed = expandTargetMediaFilterValues(selectedTargetMedias);
    return getArticleTargetMediaValues(item).some((value) => allowed.has(value));
}

export function collectCanonicalTargetMedias(values) {
    return normalizeTargetMediaList(values);
}

// Simplified version without canonicalization - just check if the media ID exists
// Kept the original name for backward compatibility
export function hasAvailableTargetMediaAlias(availableValues, mediaValue) {
    return availableValues.has(mediaValue);
}

export const ALL_SOURCE_CATEGORY_VALUES = [
    'hsl',
    'poliisi',
    'hri',
    'x',
    'scraping',
    'meeting',
];

export const ALL_SOURCE_VALUES = [
    'helsinki',
    'hsl',
    'poliisi',
    'hri',
    'x',
    'scraping',
    'meeting',
];

export const SOURCE_TO_CATEGORY = Object.freeze({
    helsinki: 'helsinki',
    hsl: 'hsl',
    poliisi: 'poliisi',
    hri: 'hri',
    x: 'x',
    scraping: 'scraping',
    meeting: 'meeting',
    mailing_list: null,
});

export function toSourceCategory(sourceType) {
    const normalized = String(sourceType ?? '').trim();
    if (!normalized) return null;
    if (normalized in SOURCE_TO_CATEGORY) return SOURCE_TO_CATEGORY[normalized];
    return normalized;
}

export const NewsSourceIcons = {
    admin: ['helsinki', 'meeting'],
    traffic: ['hsl'],
    law: ['poliisi'],
    events: ['hri'],
    x: ['x'],
    email: ['mailing_list', 'email'],
};
